import { render, staticRenderFns } from "./SidebarAboutBuffer.vue?vue&type=template&id=04e10987"
import script from "./SidebarAboutBuffer.vue?vue&type=script&lang=js"
export * from "./SidebarAboutBuffer.vue?vue&type=script&lang=js"
import style0 from "./SidebarAboutBuffer.vue?vue&type=style&index=0&id=04e10987&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports